import React from 'react'
import { Button, Col, Row } from 'reactstrap'

const AboutTeamSpirit = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding5rem1 right-padding5rem1 pymd-5 py4 p-top-bottom2rem' style={{ backgroundImage:'url("about-us/Middle-Section-Background-v1.png")', height:'100%', width:'100%'}}>
            <Row className='reverse-section'>
            <Col md='12' lg='6' className='flex-center'>
                    <div className='flex-center mt-md-0 mt-5'>
                        <img className='img-w17' src='about-us/About-Us-img3-v1.png' alt='pic' height='auto' />
                    </div>
                </Col>

                <Col md='12' lg='6' className='pt-md-3'>
                    <div className=''>
                        <div className=''>
                            <h2 className='fw-700 text-white'>
                                TEAM SPIRIT
                            </h2>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='pt-3 pe-md-5'>
                            <p className='fs-ss-16 text-montserrat fw-600 text-white lh-1-6' style={{ letterSpacing:'0.5px'}}>
                            We have recruited a team of passionate and experienced professionals who look behind all the processes in our processing units. These professionals work closely to provide you with the best lab testing services in Chicago. Additionally, we are supported by a vast distribution network that helps us fulfill clients’ demands in a scheduled time frame. Due to our transparency in the business process, competitive prices, and client-centric approach, we have continuously upgraded our lab services.

                            </p>
                        </div>

                    </div>
                </Col>

                
            </Row>
        </div>
    </div>
  )
}

export default AboutTeamSpirit